export const DEBOUNCE_DELAY = 300;

export const SET_PROBLEM_SCALING = 'SET_PROBLEM_SCALING';

export enum MISTAKE_TYPE {
    ORFO = 'Orfo',
    PUNCT = 'Punct',
    TYPO = 'Typo',
}

export const defaultAnswerStat = {
    orfo_mistakes: 0,
    typos: 0,
    is_text_dictation: false,
    punct_mistakes: 0,
};
